/* src/app/home-new/tooltip-info-components/tooltip-info-paper-weight/tooltip-info-paper-weight.component.scss */
img {
  max-width: 65px;
}
/*# sourceMappingURL=tooltip-info-paper-weight.component-DOKGHUE3.css.map */
